// дата публикации приходит как ГГГГ-ММ-ДД. Через new Date западнее Гринвича
// она съезжала бы на предыдущий день, поэтому части только переставляются
export const formatPublishDate = (date: string): string =>
    date.split('-').reverse().join('.');
